import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { getAllUserRole } from "./allUserRoleActions";
import { newUserRoleDeletion } from "./UserRoleModifyAction";
import { rolePermissionDeletion } from "../userRolePermission/rolepermissionAction";
 import {BsShieldLock} from 'react-icons/bs' ;
import $ from 'jquery';
import Swal from "sweetalert2";
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button1 from '@mui/material/Button';    


const AllUserRoles = () => {
    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const firstUpdate = useRef(true);
   
    const { userRoles, isLoading }= useSelector((state) => state.allUserRoles);
    const { isdLoading, dstatus, dmessage } = useSelector((state) => state.userRoleDelete);
    const {  mstatus, message, uroles } = useSelector((state) => state.userRoleModify);
    
   
    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);

    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );
      
      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "User Role"
      );
      
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }

   
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            dispatch(getAllUserRole());
            return;
        }

    });
    useEffect(() => {
        dispatch(getAllUserRole());
       
    }, [dispatch,dmessage]);

    if (isLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {isLoading && <Spinner variant='info' center="true" animation='border' />}

                </Container>
            </>
        );
    }

    if (userRoles.length === 0) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl">
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/CreateUserRole"><FaPlus className='fwcolor' /> Add Role</Link>{' '}</div>
                </Container>
                <Container className="my-4 mx-4 container-xl">
                    <h2>No User Role to display.....</h2>

                </Container>
            </>
        );
    }


    const renderedUserroles = userRoles
     .filter((roles) => roles.user_role !== "super admin")
    .map((roles,index) => (
        <tr key={roles.id}>
            <td>{index + 1}</td>
           
            <td>{roles.user_role}</td>   
           
            <td>{roles.status === 1 ? <span className="badge bg-success"> Enable</span> : <span className="badge bg-danger"> Disable</span>}</td>
            <td><>{menu_edit === 1 && ( <Button className="btn btn-sm btn-warning me-2" onClick={(e) => onRoleModify(e,roles.id)} ><FaEdit className='fwcolor' /></Button>)}
            {menu_edit === 1 && ( <Button className="btn btn-sm btn-primary me-2" onClick={(e) => onRolePermission(e,roles.id)}><BsShieldLock className='fwcolor'/></Button>)}
            {menu_delete === 1 && (<Button className="btn btn-sm btn-danger me-2"  onClick={(e) => onRoleDelete(e,roles.id)} ><FaTrash className='fwcolor' /></Button>)}</></td>
        </tr>
    ))

    const onRoleDelete = (e,id) => {
        e.preventDefault();
        Swal.fire({
            title: 'Are you sure want to delete the user role?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(rolePermissionDeletion(id)).then(() => {
                    dispatch(getAllUserRole()); 
                  dispatch(newUserRoleDeletion(id))
                  Swal.fire('User role Deleted Successfully!', '', 'success');
                })
            }
            else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })
        
      
             
       
    }
    const onPagepath = () => {
        navigate('/CreateUserRole');
    }

    const onRoleModify = (e,id) => {
         e.preventDefault();
         //console.log('select role '+id);
            navigate('/userRoleModify/'+id);
        }
        const onRolePermission = (e,id) => {
            e.preventDefault();
            //console.log('select role '+id);
               navigate('/rolepermission/'+id);
           }

    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                     processing: true,
                     dom: 'Bfrtip',
                    // buttons: ['copy', 'csv', 'print'],
                    buttons: ['csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div class="card" style={{marginTop:'-80px'}}>
                    <div class="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>All User Roles</h3>
                        {/* {menu_add === 1 && (<div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/CreateUserRole"><FaPlus className='fwcolor' /> Add Role</Link>{' '}</div>)} */}
                        {menu_add === 1 && (<Button1 variant="contained" onClick={onPagepath} color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                            Add Role
                        </Button1>)}
                    </div>
                    <div class="card-body">
                        <div>
                        <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
                        </div>
                        
                        <br />

                        {userRoles?.length
                            ? (
                                <table id="example" class="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedUserroles}


                                    </tbody>
                                </table>
                            ) : <p>No user role to display</p>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}

export default AllUserRoles;


